import { CircleCheck, CircleMinus, CircleX } from 'lucide-react';

import { cn } from '../../lib/utils';

/** Yes/no indicator for table cells; shape (check vs. cross) carries the meaning, color reinforces it. */
export function StatusIcon({
    value,
    label,
    falseTone = 'negative',
    className,
}: {
    value: boolean;
    label?: string;
    falseTone?: 'negative' | 'neutral';
    className?: string;
}) {
    const Icon = value ? CircleCheck : falseTone === 'neutral' ? CircleMinus : CircleX;
    return (
        <Icon
            role="img"
            aria-label={label ?? (value ? 'Yes' : 'No')}
            className={cn(
                'inline-block size-[1.125rem] shrink-0 align-text-bottom',
                value
                    ? 'text-green-600'
                    : falseTone === 'neutral'
                      ? 'text-neutral-500'
                      : 'text-red-600',
                className,
            )}
        />
    );
}
